import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { Phone, Mail, MapPin, Facebook, Linkedin, Twitter } from "lucide-react";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-excel-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_f496130d-2f72-4e5d-b90c-a2be6f930c81/artifacts/w8eyzpkg_Logo%20Excel%20Levage%20-%20Version%20Finale%20Corrig%C3%A9e.jpg"
              alt="Excel Levage"
              className="h-8 w-auto mb-4 filter brightness-0 invert"
            />
            <p className="text-gray-300 text-sm mb-4 max-w-md">
              La force maîtrisée, la sécurité garantie
            </p>
            
            <div className="space-y-2 text-sm">
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-excel-light-red" />
                <span className="text-gray-300">{t("phone")}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-excel-light-red" />
                <span className="text-gray-300">{t("email")}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold mb-4 text-white">Produits</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link 
                  to="/products" 
                  className="text-gray-300 hover:text-excel-light-red transition-colors"
                >
                  Ponts roulants
                </Link>
              </li>
              <li>
                <Link 
                  to="/products" 
                  className="text-gray-300 hover:text-excel-light-red transition-colors"
                >
                  Palans et treuils
                </Link>
              </li>
              <li>
                <Link 
                  to="/products" 
                  className="text-gray-300 hover:text-excel-light-red transition-colors"
                >
                  Systèmes de manutention
                </Link>
              </li>
              <li>
                <Link 
                  to="/products" 
                  className="text-gray-300 hover:text-excel-light-red transition-colors"
                >
                  Maintenance
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-semibold mb-4 text-white">Services</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link 
                  to="/sectors" 
                  className="text-gray-300 hover:text-excel-light-red transition-colors"
                >
                  Manufacturier
                </Link>
              </li>
              <li>
                <Link 
                  to="/sectors" 
                  className="text-gray-300 hover:text-excel-light-red transition-colors"
                >
                  Agroalimentaire
                </Link>
              </li>
              <li>
                <Link 
                  to="/about" 
                  className="text-gray-300 hover:text-excel-light-red transition-colors"
                >
                  À propos
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-gray-300 hover:text-excel-light-red transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-6 pt-6">
          <div className="text-center">
            <div className="text-gray-400 text-xs">
              © 2024 Excel Levage. Tous droits réservés.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;